import store from '@/store'

export const msgBoxConfirmAction = async (
  text, opt = { title: 'Подтверждение операции', okTitle: 'Выполнить', cancelTitle: 'Отмена' }
) => {
  const title = opt.title ? opt.title : 'Подтверждение операции'
  const okTitle = opt.okTitle ? opt.okTitle : 'Выполнить'
  const cancelTitle = opt.cancelTitle ? opt.cancelTitle : 'Отмена'
  return await msgBoxConfirm(text, title, okTitle, cancelTitle)
}

export const msgBoxConfirmCopying = async (
  text = 'Вы уверены, что хотите копировать запись?'
) => await msgBoxConfirm(text, 'Подтверждение операции копирования', 'Копировать')

export const msgBoxConfirmRemoving = async (
  text = 'Вы уверены, что хотите удалить запись?'
) => await msgBoxConfirm(text, 'Подтверждение операции удаления', 'Удалить')

const msgBoxConfirm = async (text, title, okTitle, cancelTitle = 'Отмена') => {
  return await store.getters['application/bvModal'].msgBoxConfirm(text, {
      okVariant: 'success',
      okTitle: okTitle,
      cancelVariant: 'danger',
      cancelTitle: cancelTitle,
      title: title,
      centered: true,
    })
}
